const LodashScript = options => {
  try {
    if (
      options
    ) {
      if (options.url) {
        return {
          src: options.url,
          beforeLoad: !!options.beforeLoad,
          defer: !!options.defer,
          async: !!options.async,
          onDCL: !!options.onDCL,
        }
      }

      return
    }

    console.log(`Please verify the Lodash url: ${options.url}`)
  } catch (e) {
    console.log(`There is an error. Lodash cannot be loaded.`)
  }
}

export default LodashScript